var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BModal,
    {
      attrs: {
        size: "xl",
        "modal-class": "vue-need-bootstrap",
        title: _setup.modalTitle,
        lazy: "",
        centered: "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
      },
      on: { close: _setup.onClose },
      model: {
        value: _setup.isVisible,
        callback: function ($$v) {
          _setup.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _setup.isManualAssignment
        ? _c(_setup.GenericPodAssigner, {
            attrs: {
              "template-product-id": _vm.templateProductId,
              "pod-provider": _vm.podProvider,
            },
            on: { cancel: _setup.closeModal, saved: _setup.onAssignment },
          })
        : _c(_setup.TemplateProductPodAssigner, {
            attrs: { "template-product-id": _vm.templateProductId },
            on: { save: _setup.onAssignment },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }